<template>
    <div class="product-panel" :style="design" @mouseover="showDetail=true" @mouseleave="showDetail=false">
        <a @click="openDetail()" :style="design" class="product-image-name">
            <img :src="imagePrefix+product.image" class="product-image" />
            <span class="product-name" >
                <v-clamp :max-lines="2">{{product.line1}} </v-clamp>
            </span>
        </a>

        <button class="findsim-button" :class="sitecode+'-findsim-button'" @click.stop="findMore">
            <span class="button-text">{{sbButtonText}}</span>
        </button>

        <span class="product-price" >&euro;{{priceFormat(product.price)}}</span>

        <button class="detail-button" :class="sitecode+'-detail-button'" @click.stop="openDetail()">
            <span class="button-text">More Info</span>
            <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
            </svg>
        </button>

        <div class="product-ref"><v-clamp :max-lines="1">Ref:{{product.productid}}</v-clamp></div>
    </div>
</template>

<script>
import VClamp from 'vue-clamp'
import SB from '../sbcore/sbsdk.js'

let site = require(process.env.VUE_APP_SITE_JS)

export default {
    props : ['product','fmlCtrl','highlight','eventSource','design','sbButtonText'],
  components : {VClamp},
  data: () => ({
    // favorite : 0
    serverURL : process.env.VUE_APP_SERVER_URL,
    sitecode : site.sitecode,
    showDetail : false,
    sb : null,
    imagesURL : process.env.VUE_APP_IMAGES_URL,
    styles : site.styles,
  }),
  methods : {
    findMore: function () {
      let data = {
        'sbAction' : 'FindSim',
        'productid' : this.product.productid,
        'source' : this.eventSource,
        'page' : window.location.pathname+window.location.search
      }
      this.sb.sendEvent('sbaction',data)
      this.$emit('findMore',{product:this.product,excludeHistory : true})
    },
    priceFormat:function(num) {
      try {
        return Number(num).toFixed(2)
      } 
      catch {
        return num
      } 
    },
    // toggleMyBox : function () {
    //   if (this.product.myBox != true) {
    //     this.$root.$emit('addMyBox',this.product)
    //   } else {
    //     this.$root.$emit('delMyBox',this.product)
    //   }
    // },
    // myBoxColor : function () {return this.product.myBox==true ? "red" : "grey"},
    openDetail : function () {
      let data = {
        'sbAction' : 'getDetail',
        'productid' : this.product.productid,
        'source' : this.eventSource,
        'page' : window.location.pathname+window.location.search
      }
      this.sb.sendEvent('sbaction',data)
      window.top.location.href = this.product.href
      this.$root.$emit('addClickBox', this.product)
    },
    // getStyle : function (ss) {
    //   let outString = ""
    //   for (let s of ss) {
    //     if (this.widgetClasses[s] != undefined) {
    //       outString = outString + this.widgetClasses[s]
    //     }
    //   }
    //   return outString
    // }
  },
  created () {
    this.sb = new SB()
    this.sb.init()
  },
  computed : {
    imagePrefix : function () {return site.productImagePrefix==undefined ? '' : site.productImagePrefix},
    highlightColor : function () {return this.highlight=="true" ? "LightGrey" : "white"}
  }
};
</script>
<style scoped>



.did-findsim-button {
    display: block;
    border: 1px solid #000;
    color: #000;
    background-color: #FFF;
    position: relative;
    margin: 5px 0;
    text-align: center;
    padding: 6px 5px 8px;
    font-size: 12px;
    line-height: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    width :100%;
    height: inherit;
}

.did-findsim-button::after {
    position: absolute;
    content: '';
    top: 10px;
    right: 10px;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    opacity: .5;
    /*background-color: green;*/
    background-color: #E30613;
    animation: pulse 2s infinite;
    box-sizing: border-box;
}

.did-findsim-button .button-text {
    width : 70%;
}

.did-findsim-button:hover, .DID-V1-fml-button:focus, .DID-V1-fml-button:active {
    border: 1px solid #E30613;
    color: #FFF;
    background-color: #E30613;
    animation: none;
}

.did-detail-button {
    display: block;
    background-color: #e30613;
    color: #fff;
    border: 1px solid #e30613;
    border-radius: 20px;
    font-family: 'NolanNext-Medium', sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 14px;
    line-height: 1.25;
    padding: 2px 2px 3px;
    margin: 10px auto;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
        border-radius: 5px;
    text-transform: capitalize;
    font-weight: bold;
    width : 100%;
    height : 70%;
    cursor : pointer;
}

.did-detail-button:hover {
    background-color: #b1050f;
    border: 1px solid #b1050f;
}

/* Louis Copeland demo */

.louis_copeland-findsim-button {
    display: block;
    border: 1px solid #000;
    color: #000;
    background-color: #FFF;
    position: relative;
    margin: 5px 0;
    text-align: center;
    padding: 6px 5px 8px;
    font-size: 12px;
    line-height: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    width :100%;
    height: inherit;
}

.louis_copeland-findsim-button::after {
    position: absolute;
    content: '';
    top: 10px;
    right: 10px;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    opacity: .5;
    /*background-color: green;*/
    background-color: #763a6a;
    animation: pulse 2s infinite;
    box-sizing: border-box;
}

.louis_copeland-findsim-button .button-text {
    width : 70%;
}

.louis_copeland-findsim-button:hover, .louis_copeland-fml-button:focus, .louis_copeland-fml-button:active {
    border: 1px solid #763a6a;
    color: #FFF;
    background-color: #763a6a;
    animation: none;
}

.louis_copeland-detail-button {
    display: block;
    background-color: #763a6a;
    color: #fff;
    border: 1px solid #763a6a;
    border-radius: 20px;
    font-family: 'NolanNext-Medium', sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 14px;
    line-height: 1.25;
    padding: 2px 2px 3px;
    margin: 10px auto;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
        border-radius: 5px;
    text-transform: capitalize;
    font-weight: bold;
    width : 100%;
    height : 70%;
    cursor : pointer;
}

.louis_copeland-detail-button:hover {
    background-color: #763a6a;
    border: 1px solid #763a6a;
}

/* Petstop demo */

.petstop-findsim-button {
    display: block;
    border: 1px solid #000;
    color: #000;
    background-color: #FFF;
    position: relative;
    margin: 5px 0;
    text-align: center;
    padding: 6px 5px 8px;
    font-size: 12px;
    line-height: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    width :100%;
    height: inherit;
}

.petstop-findsim-button::after {
    position: absolute;
    content: '';
    top: 10px;
    right: 10px;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    opacity: .5;
    /*background-color: green;*/
    background-color: ##009fe3;
    animation: pulse 2s infinite;
    box-sizing: border-box;
}

.petstop-findsim-button .button-text {
    width : 70%;
}

.petstop-findsim-button:hover, .petstop-fml-button:focus, .petstop-fml-button:active {
    border: 1px solid #009fe3;
    color: #FFF;
    background-color: #009fe3;
    animation: none;
}

.petstop-detail-button {
    display: block;
    background-color: #009fe3;
    color: #fff;
    border: 1px solid #009fe3;
    border-radius: 20px;
    font-family: 'NolanNext-Medium', sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 14px;
    line-height: 1.25;
    padding: 2px 2px 3px;
    margin: 10px auto;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
        border-radius: 5px;
    text-transform: capitalize;
    font-weight: bold;
    width : 100%;
    height : 70%;
    cursor : pointer;
}

.petstop-detail-button:hover {
    background-color: #009fe3;
    border: 1px solid #009fe3;
}

/* Greenes Shoes demo */

.greenesshoes-findsim-button {
    display: block;
    border: 1px solid #000;
    color: #000;
    background-color: #FFF;
    position: relative;
    margin: 5px 0;
    text-align: center;
    padding: 6px 5px 8px;
    font-size: 12px;
    line-height: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    width :100%;
    height: inherit;
}

.greenesshoes-findsim-button::after {
    position: absolute;
    content: '';
    top: 10px;
    right: 10px;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    opacity: .5;
    /*background-color: green;*/
    background-color: #84bd00;
    animation: pulse 2s infinite;
    box-sizing: border-box;
}

.greenesshoes-findsim-button .button-text {
    width : 70%;
}

.greenesshoes-findsim-button:hover, .greenesshoes-fml-button:focus, .greenesshoes-fml-button:active {
    border: 1px solid #84bd00;
    color: #FFF;
    background-color: #84bd00;
    animation: none;
}

.greenesshoes-detail-button {
    display: block;
    background-color: #84bd00;
    color: #fff;
    border: 1px solid #84bd00;
    border-radius: 20px;
    font-family: 'Avenir Next', sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 14px;
    line-height: 1.25;
    padding: 2px 2px 3px;
    margin: 10px auto;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
        border-radius: 5px;
    text-transform: capitalize;
    font-weight: bold;
    width : 100%;
    height : 70%;
    cursor : pointer;
}

.greenesshoes-detail-button:hover {
    background-color: #84bd00;
    border: 1px solid #84bd00;
}

/* Tony Kealys */

.tony_kealys-findsim-button {
    display: block;
    border: 1px solid #000;
    color: #000;
    background-color: #FFF;
    position: relative;
    margin: 5px 0;
    text-align: center;
    padding: 6px 5px 8px;
    font-size: 12px;
    line-height: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    width :100%;
    height: inherit;
}

/*.tony_kealys-findsim-button::after {
    position: absolute;
    content: '';
    top: 10px;
    right: 10px;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    opacity: .5;
    background-color: #1770e4;
    animation: pulse 2s infinite;
    box-sizing: border-box;
}
*/
.tony_kealys-findsim-button .button-text {
    width : 70%;
}

.tony_kealys-findsim-button:hover, .tony_kealys-fml-button:focus, .tony_kealys-fml-button:active {
    border: 1px solid #1770e4;
    color: #FFF;
    background-color: #1770e4;
    animation: none;
}

.tony_kealys-detail-button {
    display: block;
    background-color: #1770e4;
    color: #fff;
    border: 1px solid #1770e4;
    border-radius: 20px;
    font-family: 'Avenir Next', sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 14px;
    line-height: 1.25;
    padding: 2px 2px 3px;
    margin: 10px auto;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
        border-radius: 5px;
    text-transform: capitalize;
    font-weight: bold;
    width : 100%;
    height : 70%;
    cursor : pointer;
}

.tony_kealys-detail-button:hover {
    background-color: #1770e4;
    border: 1px solid #1770e4;
}


.mcmahons-findsim-button {
    display: block;
    border: 1px solid #000;
    color: #000;
    background-color: #FFF;
    position: relative;
    margin: 5px 0;
    text-align: center;
    padding: 6px 5px 8px;
    font-size: 12px;
    line-height: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    width :100%;
    height: inherit;
}

.mcmahons-findsim-button::after {
    position: absolute;
    content: '';
    top: 10px;
    right: 10px;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    opacity: .5;
    /*background-color: green;*/
    background-color: #006f3e;
    animation: pulse 2s infinite;
    box-sizing: border-box;
}

.mcmahons-findsim-button .button-text {
    width : 70%;
}

.mcmahons-findsim-button:hover, .mcmahons-fml-button:focus, .mcmahons-fml-button:active {
    border: 1px solid #006f3e;
    color: #FFF;
    background-color: #006f3e;
    animation: none;
}

.mcmahons-detail-button {
    display: block;
    background-color: #006f3e;
    color: #fff;
    border: 1px solid #006f3e;
    border-radius: 20px;
    font-family: 'Avenir Next', sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 14px;
    line-height: 1.25;
    padding: 2px 2px 3px;
    margin: 10px auto;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
        border-radius: 5px;
    text-transform: capitalize;
    font-weight: bold;
    width : 100%;
    height : 70%;
    cursor : pointer;
}

.mcmahons-detail-button:hover {
    background-color: #006f3e;
    border: 1px solid #006f3e;
}





/*
.detail-button {
    grid-area: detail;
    background-color: #e30613;    
    color: #fff;
    border: 1px solid #e30613;
    font-family: 'NolanNext-Medium', sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 14px;
    line-height: 1.25;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
    border-radius: 5px;
    text-transform: capitalize;
    font-weight: bold;
    cursor : pointer;
}

.detail-button:hover {
    background-color: #b1050f;
    border: 1px solid #b1050f;
}

.findsim-button {
  grid-area : findsim;

}

.findsim-button::after {
    position: absolute;
    content: '';
    top: 10px;
    right: 15%;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    opacity: .5;
    background-color: #E30613;
    animation: pulse 2s infinite;
    box-sizing: border-box;
}

.findsim-button:hover, .findsim-button:focus, .findsim-button:active {
    border: 1px solid #E30613;
    color: #FFF;
    background-color: #E30613;
    animation: none;
}*/

a {
    text-decoration: none;
    text-decoration-color: red;
    cursor: pointer;
    margin : 2px;
    border : 1px solid var(--background-color);
    border-radius : 5px;
}

a:hover {
    border : 1px solid var(--controls-color);
    border-radius : 5px;
}

.product-image {
    grid-area: image;    

    margin : 2px;
    /*padding : 2px;*/

    height : var(--image-height);
    width : var(--image-width);

    display : block;
    margin-left : auto;
    margin-right: auto;

    object-fit : contain;
    
}

.product-name {
    grid-area: name;    
    font-family: NolanNext-Bold,sans-serif;
    font-size: small; 
    font-weight: 700;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.product-image-name {
    grid-name : image-name;
}

.product-price {
    grid-area: price;     

    font-family: NolanNext-Bold,sans-serif;
    font-weight: 700;
    color: #e30613;
    font-size: 24px;
    margin-left: 0;
    text-align: center;
    -webkit-box-pack: center;
  }

.product-ref {
    grid-area: ref;
    
    font-family: GillSansforJL,Arial;
    font-size: x-small;
}

.product-panel {
    display : grid;
    grid-template-areas: var(--product-areas);
    row-gap : 0px;
}

</style>

<style scoped >
</style>
